(function () {
    'use strict';

    function entityActivitiesController(milestonesAndProfile, myProfileDataService, milestoneModalService,
        entityProfilePercentageCompleteCalculatorService) {

        var vm = this;
        vm.entity = milestonesAndProfile.profile;
        vm.milestones = milestonesAndProfile.milestones;
        vm.baseProfileCompletedPercentage = 30;


        vm.showIncompleteProfileMessage = entityProfilePercentageCompleteCalculatorService.calculateProfileCompletedPercentage(vm.entity,
            vm.baseProfileCompletedPercentage) !== 100;

        milestoneModalService.getMilestonesAndTemplates(vm.milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });
    }

    entityActivitiesController.$inject = ['milestonesAndProfile', 'myProfileDataService', 'milestoneModalService',
        'entityProfilePercentageCompleteCalculatorService'];

    angular.module('ecap.dashboards').controller('entityActivitiesController', entityActivitiesController);
})();
